/* DNA Motion — plays a product card's featured turnaround video on hover.
   Cards render a <video class="dna-motion-card"> with no src (see snippets/dna-motion-card.liquid).
   On first hover we attach the mp4, play, and fade it in over the card image;
   leaving the card pauses and rewinds so the next hover starts from the front.
   Hover-capable (fine pointer) devices only — touch grids stay static images;
   product pages autoplay their featured video via the theme itself.
   Skips entirely for reduced-motion and Save-Data users. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.connection && navigator.connection.saveData) return;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function activate(video) {
    if (!video.dataset.dnaLoaded) {
      video.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
      video.dataset.dnaLoaded = '1';
      video.load();
    }
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* blocked — card keeps its image */ });
  }

  function deactivate(video) {
    if (!video.paused) video.pause();
    video.classList.remove('is-playing');
    try { video.currentTime = 0; } catch (e) { /* not seekable yet */ }
  }

  function bind() {
    var vids = document.querySelectorAll('video.dna-motion-card:not([data-dna-bound])');
    for (var i = 0; i < vids.length; i++) {
      (function (video) {
        video.dataset.dnaBound = '1';
        video.addEventListener('playing', function () { video.classList.add('is-playing'); });
        var card = video.closest('.grid-product') || video.parentElement;
        card.addEventListener('mouseenter', function () { activate(video); });
        card.addEventListener('mouseleave', function () { deactivate(video); });
        card.addEventListener('focusin', function () { activate(video); });
        card.addEventListener('focusout', function (e) {
          if (!card.contains(e.relatedTarget)) deactivate(video);
        });
      })(vids[i]);
    }
  }

  bind();
  /* Grids re-render client-side (collection filtering, predictive search, carousels) */
  new MutationObserver(bind).observe(document.documentElement, { childList: true, subtree: true });
})();
